import {
  WORKSPACE_ROLE_PERMISSIONS,
  type Permission,
  type WorkspaceRole,
} from "@papersflow/contracts";

export function permissionsForRole(role: WorkspaceRole): readonly Permission[] {
  return WORKSPACE_ROLE_PERMISSIONS[role];
}

export function hasPermission(permissions: readonly Permission[], permission: Permission): boolean {
  return permissions.includes(permission);
}

export interface AuthenticatedPrincipal {
  readonly userId: string;
  readonly sessionId: string;
  readonly email?: string;
}

export interface WorkspaceAuthorization {
  readonly workspaceId: string;
  readonly role: WorkspaceRole;
  readonly permissions: readonly Permission[];
}
